import { mapTree } from '@asamco/utils';

import { MainMenu, MenuItem } from '../menu-item.interface';

/**
 * Finds the menu item by id and updates it's settings
 * @param menuItemId The ID of the menu item to update
 * @param newSettings New settings of the menu item
 */
export function updateMenuItem(menu: MainMenu, menuItemId: MenuItem['id'], newSettings: Partial<MenuItem>): MainMenu {
	return mapTree(menu, 'children', menuItem => {
		if (menuItem.id === menuItemId) {
			return {
				...menuItem,
				...newSettings,
			};
		} else {
			return menuItem;
		}
	});
}
